<template>
<b-modal ref="apiErrorModal" :visible="shown" centered title="Wystąpił błąd" @hidden="hide" ok-only>
  Wystąpił błąd: {{error}}
</b-modal>
</template>

<script>
import { WINDOW_API_ERROR_HIDE } from "../store/mutations.type";

export default {
  name: "ApiErrorWindow",
  computed: {
    shown() {
      return this.$store.getters.apiErrorWindowVisible;
    },
    error() {
      let error = this.$store.getters.apiErrorMessage;
      
      if (typeof error === "string") {
        return error;
      }

      if (error.body && error.response) {
        return error.response.statusCode + " - " + error.body.error;
      }

      if (error.message) {
        return error.message;
      }

      if (error.err && typeof error.err.message === "string") {
        return error.err.message;
      }

      return "Niezidentyfikowany błąd.";
    }
  },
  methods: {
    hide() {
      this.$store.commit(WINDOW_API_ERROR_HIDE);
    }
  }
};
</script>
